import {
    TOUR_ADD_REVIEW_DETAIL_SUCCESS,
    TOUR_ADD_REVIEW_DETAIL_ERROR
  } from "../Constant/TourAddReviewConstant";
  
  const initialState = {
    loading: false,
    data:null
      
  };
  
  export default function TourAddReviewDataReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case TOUR_ADD_REVIEW_DETAIL_SUCCESS:
        return {
          ...state,
          loading: true,
        };
      case TOUR_ADD_REVIEW_DETAIL_ERROR:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  }
  